module.exports = __webpack_public_path__ + "static/media/crypto.7bb679a8.svg";